module.exports = __webpack_public_path__ + "img/upgrade.a02c15a6.png";